import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

export const organizationSchema = {
    organizationName: z
        .string()
        .trim()
        .min(1)
        .max(256)
        .refine((name) => /[a-zA-Z0-9]/.test(name), {
            message: 'Organization name must contain at least one alphanumeric character',
        }),
    organizationDescription: z.string().trim().min(1).max(1024),
    pocName: z.string().trim().min(1).max(256),
    pocEmail: z.string().trim().email(),
    pocPhoneNumber: z
        .string()
        .refine((value) => isPossiblePhoneNumber(value, 'US'))
        .optional(),
};
